/*
This is the silver badge that represents a main number
or a lucky star in a ticket entry/card.
*/

import star from "../../assets/icons/star.svg";

export interface BadgeProps {
  selected: boolean;
  onSelect?: (selected: boolean) => void;
  isStar: boolean;
  isCorrect?: boolean;
  children?: React.ReactNode;
  adaptive?: boolean;
  pulsing?: boolean;
  isGrayedOut?: boolean;
}

export default function Badge(props: BadgeProps) {
  return (
    <div
      onClick={
        props.onSelect != undefined
          ? () => props.onSelect!(!props.selected)
          : () => { }
      }
      className={`${props.onSelect == undefined ? "cursor-default" : "cursor-pointer"} select-none relative w-6 rounded-full py-1 m-0.5 flex justify-center ${props.onSelect != undefined ? "hover:scale-105 duration-250" : "cursor-auto"}  
            ${props.pulsing
          ? "bg-brinkPink animate-pulse duration-250"
          : props.selected
            ? "bg-gradient-to-br from-cadillac to-persian-pink"
            : (props.isCorrect ?? false)
              ? "bg-gradient-to-br from-mango to-crail"
              : props.isGrayedOut
                ? "bg-gradient-to-br from-silver-light-light to-emperor"
                : "bg-gradient-to-br from-white to-emperor"
        }
            `}
    >
      <div
        className={`font-archb ~text-sm/reg ${props.isGrayedOut ? "text-emperor" : "text-cinder"}`}
      >
        {props.children}
      </div>
      {props.isStar && (
        <img
          src={star}
          className="absolute h-4 w-4 bottom-starbmax right-starrmax"
          alt="star"
        />
      )}
    </div>
  );
}
